var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChelly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.3 24c-0.8-7.8 8.6-20.4 14.8-19.7 6.2 0.7 6.1 5.9 6.4 10.3l8.2-8C27.5 2.4 22.5 0 17.1 0 5 0-3.4 12.1 1.3 24Zm3.7 0.8c2.5 3.5 11.5-5.2 14.5-7.5-0.3-3.8-0.6-8.8-2.4-9.6-5.2-2.5-14.8 12.8-12.1 17.1zM32.5 9.3c-1.5 1.5-5.3 5.4-9.7 9.3 0.8 6.6 0.6 5.9 4.6 6.7 2.2 0.5 1.5 3.3-0.5 3.1-4.9-0.5-6.6-2.3-7-7.6-5 4-11.3 10.2-16.3 6.9 3.3 4 8.2 6.3 13.4 6.3 12.6 0.1 21.1-13.3 15.5-24.7z",
    fill: "#19d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChelly);
export default __webpack_public_path__ + "static/media/chelly.5539bc474acb4624dd75c08c0daaee52.svg";
export { ForwardRef as ReactComponent };